module.exports = __webpack_public_path__ + "./images/cc.122ab6.svg";